import { Dots } from "./loadingDots.styles";

const LoadingDots = () => {
  return <Dots />;
};

export default LoadingDots;
